import * as React from 'react';

import { SVGProps } from './type';

const SvgComponent = (props: SVGProps) => {
  const { color = '#1890FF', size = 24, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M15.17 2.677a1.5 1.5 0 011.646.329l4.178 4.178a1.501 1.501 0 010 2.132L9.746 20.565a.75.75 0 01-.496.218L4.534 21H4.5A1.5 1.5 0 013 19.467l.216-4.716a.75.75 0 01.22-.496L14.683 3.006a1.5 1.5 0 01.487-.33zm4.765 5.569L15.75 4.06l-.004.004L4.702 15.109l-.201 4.39 4.39-.2 11.048-11.05-.004-.003z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.22 5.47a.75.75 0 011.06 0l5.25 5.25a.75.75 0 11-1.06 1.06l-5.25-5.25a.75.75 0 010-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgComponent;
